import { Injectable } from "@angular/core";
import { LanguageService } from "../../services/language.service";






@Injectable({ providedIn: 'root' })
export class SharedFacade
{



   constructor(
      private language_s: LanguageService
   ) {}






}
